/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './revokeAccountCredentials.defs.js'
export * as $defs from './revokeAccountCredentials.defs.js'
